<div class="recall-encode">
  <div class="cog-spacer"></div>

  <div class="cog-text-center cog-mb-16">
    <h2 class="cog-h2">{{ 'cognitive.sharpV2.recallEncode.title' | translate }}</h2>
    <p class="cog-subtitle">{{ 'cognitive.sharpV2.recallEncode.subtitle' | translate }}</p>
  </div>

  <div
    id="encode-scene"
    class="cog-card cog-card-accent"
    style="text-align:center;padding:28px 20px;min-height:120px;display:flex;align-items:center;justify-content:center"
  >
    <p *ngIf="phase === 'intro'" style="font-size:14px;color:var(--sharp-text-muted)">
      {{ 'cognitive.sharpV2.recallEncode.hiddenPlaceholder' | translate }}
    </p>

    <div *ngIf="phase === 'memorize'" style="width:100%">
      <p
        style="font-size:19px;font-weight:500;color:var(--sharp-navy);line-height:2.2;margin:0"
      >
        <ng-container *ngFor="let part of sceneParts"
          ><span
            *ngIf="part.kind === 'text'"
            class="enc-part"
            [style.animation-delay.s]="part.delay"
            >{{ part.text }}</span
          ><strong
            *ngIf="part.kind === 'chip'"
            class="enc-part"
            [style.background]="part.bg"
            [style.color]="part.color"
            [style.animation-delay.s]="part.delay"
            style="padding:2px 8px;border-radius:6px"
          >{{ part.text }}</strong></ng-container
        >
      </p>
      <p style="font-size:12px;color:var(--sharp-text-muted);margin-top:12px">
        {{ 'cognitive.sharpV2.recallEncode.pictureHint' | translate }}
      </p>
    </div>
  </div>

  <div
    *ngIf="phase === 'memorize'"
    id="encode-timer-wrap"
    style="display:flex;align-items:center;justify-content:center;gap:10px;margin:16px 0"
  >
    <div
      id="encode-timer-ring"
      class="cog-timer-ring"
      [class.urgent]="timer <= 3"
      [class.clickable]="canSkipTests()"
      [style.--pct]="timerPct"
      style="width:52px;height:52px"
      (click)="skipTimer()"
    >
      <div class="cog-timer-inner" style="width:40px;height:40px">
        <span id="encode-timer" style="font-size:18px;font-weight:800">{{ timer }}</span>
      </div>
    </div>
    <span
      id="encode-timer-label"
      style="font-size:13px;color:var(--sharp-text-muted)"
    >
      {{
        (timer <= 3
          ? 'cognitive.sharpV2.recallEncode.almostThere'
          : 'cognitive.sharpV2.recallEncode.memorizeLabel'
        ) | translate
      }}
    </span>
  </div>

  <div class="cog-spacer"></div>

  <!-- INTERRUPTED: the shortened look is thrown away, a new sentence runs (brief 3.3) -->
  <ng-container *ngIf="phase === 'interrupted'">
    <div class="cog-text-center cog-mb-16">
      <h2 class="cog-h2">{{ 'cognitive.sharpV2.recallEncode.interruptedTitle' | translate }}</h2>
      <p class="cog-subtitle">{{ 'cognitive.sharpV2.recallEncode.interruptedBody' | translate }}</p>
    </div>
    <button type="button" class="cog-btn cog-btn-primary" (click)="resumeAfterInterrupt()">
      {{ 'cognitive.sharpV2.recallEncode.interruptedCta' | translate }}
    </button>
  </ng-container>

  <button
    *ngIf="phase === 'intro'"
    id="encode-reveal-btn"
    type="button"
    class="cog-btn cog-btn-primary"
    (click)="reveal()"
  >
    {{ 'cognitive.sharpV2.recallEncode.revealBtn' | translate }}
  </button>
</div>
